import { render, staticRenderFns } from "./viewInfo.vue?vue&type=template&id=5245aba8&scoped=true"
import script from "./viewInfo.vue?vue&type=script&lang=js"
export * from "./viewInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245aba8",
  null
  
)

export default component.exports